import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Commands, Results } from '@local/client-contracts';
import hljs from 'highlight.js';
import { CodeJarContainer } from 'ngx-codejar';
import { decode } from 'html-entities';

@Component({
  selector: 'result-code-block',
  templateUrl: './result-code-block.component.html',
  styleUrls: ['./result-code-block.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResultCodeBlockComponent {
  code: string;
  private selectionSnippet: string;
  private _model: Results.CodeBlock;
  private _highlights: Array<string> = [];
  private readonly TEXT_BETWEEN_TAGS_RGX = new RegExp(/>([^<]*)</, 'gi');

  @Input() set model(model: Results.CodeBlock) {
    this._model = model;
    this.initData();
  }

  @Input() set highlights(value: Array<string>) {
    this._highlights = value;
    this.initData();
  }

  @ViewChild('codejar') codejarRef: CodeJarContainer;

  get highlights(): Array<string> {
    return this._highlights;
  }

  constructor(private cdr: ChangeDetectorRef) {}

  highlightMethod(editor: CodeJarContainer) {
    if (editor.textContent !== null && editor.textContent !== undefined) {
      editor.innerHTML = editor.textContent;
    }
  }

  mouseup() {
    this.selectionSnippet = window.getSelection().toString();
    if (!this.selectionSnippet) {
      this.codejarRef['editor']['nativeElement']?.blur();
    }
  }

  private initData() {
    let newText = hljs.highlight(this._model.content, {
      language: this._model.language,
    }).value;

    if (this.highlights?.length) {
      this.highlights.forEach((word) => {
        newText = this.replace(newText, word);
      });
    }

    this.code = newText;
    this.cdr.markForCheck();
  }

  private replace(text: string, word: string): string {
    return text.replace(this.TEXT_BETWEEN_TAGS_RGX, (match) => {
      const regex = new RegExp(word, 'gi');
      const newText = decode(match, { level: 'all' });
      return newText.replace(regex, (match: string) => {
        return `<mark class="text-highlight">${match}</mark>`;
      });
    });
  }
}
